
import { handleActions } from 'redux-actions'
import { setDisconnectMessage, confirmCloseMessage } from './../actions/disconnect'
import { logger } from './../lib/utils/logger'

const initialState = {
  disconnectMessage: '',
  error: null,
  confirmCloseMessage: false,
}

export const disconnectReducer = handleActions({
  [setDisconnectMessage] (prevState, action) {
    const { message: disconnectMessage, error } = typeof action.payload === 'string'
      ? { message: action.payload, error: null }
      : action.payload
    if (error) {
      logger('disconnect (error)', error, disconnectMessage)
    }
    return {
      ...prevState,
      disconnectMessage,
      error,
      confirmCloseMessage: false,
    }
  },
  [confirmCloseMessage] (prevState, action) {
    return {
      ...prevState,
      confirmCloseMessage: Boolean(action.payload),
    }
  },

}, initialState)
